/** @format */

import React from "react";
import UsersTable from "./UsersTable";
import { IUsers } from "./AccountInfoPage.types";
import { Tabs, Spin } from "antd";
import AccountContexts from "./AccountContexts/AccountContexts";
import AccountEdgeDeployments from "./AccountEdgeDeployments/AccountEdgeDeployments";
import LogsPage from "./AccountLogs";
import { AccountType, IAccountsList } from "../MainContent.types";
import { Helmet } from "react-helmet";
import AccountPhoneNumbers from "../../../components/AccountPhoneNumbers";
import AccountGeneral from "./AccountGeneral/AccountGeneral";
import type { TabsProps } from "antd";
import AccountRates from "./AccountRates";
import AccountSA from "./AccountSA";
import GrafanaPage from "./GrafanaPage";
 
interface IAccountInfoPageViewProps {
  users: IUsers[];
  account: IAccountsList | undefined;
  params: { id: string };
  fetchAndSetUsers: () => void;
  isLoading: boolean;
}

const AccountInfoPageView: React.FC<IAccountInfoPageViewProps> = ({
  users,
  account,
  params,
  fetchAndSetUsers,
  isLoading,
}) => {
  const tabsArray: TabsProps["items"] = [
    {
      key: "0",
      label: "General",
      children: (
        <Spin spinning={isLoading}>
          <AccountGeneral accountData={account ? [account] : []} />
        </Spin>
      ),
    },
    {
      key: "1",
      label: "Users",
      children: (
        <Spin spinning={isLoading}>
          <UsersTable users={users} fetchAndSetUsers={fetchAndSetUsers} />
        </Spin>
      ),
    },
    {
      key: "2",
      label: "Contexts",
      children: <AccountContexts params={params} />,
    },
    {
      key: "3",
      label: "Edge Deployments",
      children: <AccountEdgeDeployments params={params} />,
    },
    // {
    //   key: "4",
    //   label: "Logs",
    //   children: <LogsPage users={users} />,
    // },
    {
      key: "5",
      label: "Phone Numbers",
      children: (
        <AccountPhoneNumbers
          tableSize="small"
          phoneNumberData={account ? account.phoneNumbers : []}
          columns={{
            number: true,
            tollFree: true,
            location: true,
            monthlyCost: true,
            purchaseDate: true,
            lastBilledDate: true,
            status: true,
            lastMrcDate: true,
          }}
        />
      ),
    },
    {
      key: "6",
      label: "Rate-Limits",
      children: <AccountRates account={account} />,
    },
    {
      key: "7",
      label: "Grafana",
      children: <GrafanaPage
      accountId={params.id}
       />,
    },
    ...(account &&
    account.accountType &&
    account.accountType === AccountType.SpeechAnalytics
      ? [
          {
            key: "8",
            label: "SA",
            children: <AccountSA account={account} />,
          },
        ]
      : []),
  ];

  return (
    <div className="account-info-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>VG Admin-{account?.webName || 'Loading...'}</title>
      </Helmet>
      <div>
        <div
          style={{
            display: "inline-block",
            marginBottom: "1rem",
            marginRight: "1rem",
          }}
        >
          <span style={{ fontWeight: 500 }}>Account Name: </span>
          <span>{account?.webName || 'Loading...'}</span>
        </div>
        <div
          style={{
            display: "inline-block",
            marginBottom: "1rem",
            marginRight: "1rem",
          }}
        >
          <span style={{ fontWeight: 500 }}>Account UUID: </span>
          <span>{params.id}</span>
        </div>
      </div>
      <Tabs defaultActiveKey="0" type="card" items={tabsArray} />
    </div>
  );
};

export default AccountInfoPageView;
